import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Sparkles } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(() => {
    if (typeof window === 'undefined') return 62;
    const saved = sessionStorage.getItem('mama-spots');
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 45) * 1;
      return Math.min(value + increment, 94);
    }
    return 62 + Math.floor(Math.random() * 6);
  });
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 27,
    s: 25
  });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    sessionStorage.setItem('mama-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 94) return prev;
        const increment = Math.random() < 0.3 ? 1 : 0;
        return Math.min(prev + increment, 94);
      });
    }, 30000 + Math.random() * 30000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-dark via-brand-pinkDark to-brand-dark text-white shadow-md border-b border-brand-pinkLight/30" data-id="element-313">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-314">
        <div className="md:hidden overflow-hidden relative" data-id="element-315">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-316">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-317">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-surfaceLight" data-id="element-318">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-319" />
                  <span data-id="element-320">Precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-321">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-surfaceLight/50 shrink-0" data-id="element-322" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-323">
                  <Sparkles className="w-3.5 h-3.5 shrink-0 animate-pulse text-brand-surfaceLight" data-id="element-324" />
                  <span data-id="element-325">
                    <strong className="tabular-nums text-brand-surfaceLight" data-id="element-326">
                      {spotsTaken}%
                    </strong>{' '}
                    de cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-surfaceLight/50 shrink-0" data-id="element-327" />
                <a href="#pricing" className="inline-flex items-center gap-1 bg-brand-gold text-brand-dark font-bold px-2.5 py-0.5 rounded-full text-[11px] shrink-0" data-id="element-328">
                  Ver santuario →
                </a>
              </div>)}
          </motion.div>
        </div>

        <div className="hidden md:flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm font-medium" data-id="element-329">
          <div className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap text-brand-surfaceLight" data-id="element-330">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-331" />
            <span data-id="element-332">Precio de lanzamiento cierra en</span>
            <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-333">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="hidden md:block w-px h-4 bg-brand-surfaceLight/40 shrink-0" data-id="element-334" />
          <div className="hidden md:flex items-center gap-2 whitespace-nowrap" data-id="element-335">
            <Sparkles className="w-4 h-4 shrink-0 animate-pulse text-brand-surfaceLight" data-id="element-336" />
            <span data-id="element-337">
              <strong className="tabular-nums text-brand-surfaceLight" data-id="element-338">
                {spotsTaken}%
              </strong>{' '}
              de cupos tomados
            </span>
          </div>
          <a href="#pricing" className="hidden sm:inline-flex items-center gap-1 bg-brand-gold text-brand-dark font-bold px-3 py-1 rounded-full text-[11px] md:text-xs hover:bg-brand-goldLight transition-colors shrink-0" data-id="element-339">
            Ver santuario →
          </a>
        </div>
      </div>
    </div>;
}